import { render, staticRenderFns } from "./PhotoAggregateView.vue?vue&type=template&id=539c4cb9&scoped=true&"
import script from "./PhotoAggregateView.vue?vue&type=script&lang=js&"
export * from "./PhotoAggregateView.vue?vue&type=script&lang=js&"
import style0 from "./PhotoAggregateView.vue?vue&type=style&index=0&id=539c4cb9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539c4cb9",
  null
  
)

export default component.exports